import { render } from "./HeaderPage.vue?vue&type=template&id=3ce3b5b7&scoped=true"
import script from "./HeaderPage.vue?vue&type=script&lang=js"
export * from "./HeaderPage.vue?vue&type=script&lang=js"

import "./HeaderPage.vue?vue&type=style&index=0&id=3ce3b5b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce3b5b7"]])

export default __exports__